import React from 'react';

const SvgUy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="UY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="UY_svg__b" fill="#fff">
        <use xlinkHref="#UY_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M13.333 13.333v-2.666 2.666H28V16H0V0h6.667zm0-8V8 5.333zM0 18.667h28V20H0v-1.333z"
        fill="#0E4DC5"
        mask="url(#UY_svg__b)"
      />
      <path
        d="M6.667 9.321l-.89 1.329-.226-1.583-1.378.81.484-1.524-1.594.133L4.16 7.322 2.667 6.75l1.493-.572-1.097-1.163 1.594.132-.484-1.524 1.378.81.226-1.582.89 1.328.89-1.328.225 1.583 1.379-.811-.484 1.524 1.594-.132-1.098 1.163 1.494.572-1.494.572 1.098 1.164-1.594-.133.484 1.525-1.379-.811-.225 1.583-.89-1.329zm0-.025a2.545 2.545 0 1 0 0-5.091 2.545 2.545 0 0 0 0 5.09zm0-.63a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        fill="#FED443"
        mask="url(#UY_svg__b)"
      />
    </g>
  </svg>
);

export default SvgUy;
